import registry from '../../../config/locales.json';

/** Shared release-time registry; adding a translation still requires bundle imports. */
export type SupportedLocale = keyof typeof registry.languages;
export const FALLBACK_LOCALE = registry.fallback as SupportedLocale;
export function activeLocales(surface: string): SupportedLocale[] {
    return (Object.keys(registry.languages) as SupportedLocale[]).filter((code) => {
        const language = registry.languages[code];
        return language.status === 'active' && language.surfaces.includes(surface);
    });
}
export function isActiveLocale(value: unknown, surface: string): value is SupportedLocale {
    return typeof value === 'string' && activeLocales(surface).some((code) => code === value);
}
export function localeName(locale: SupportedLocale): string {
    return registry.languages[locale].name;
}
